export const MY_MONITORING_UNIVERSAL_LINKS = ['mymonitoring.app', 'dev.mymonitoring.app']

export const RADIONET_PORTAL_UNIVERSAL_LINKS = ['radionetportal.com']

